import { Link } from 'react-router-dom';

export function NotFoundPage(): JSX.Element {
  return (
    <section className="not-found">
      <h1>Not found</h1>
      <p>This page doesn&rsquo;t exist yet.</p>
      <Link to="/dashboard">Back to the dashboard</Link>
    </section>
  );
}
